import { combineEpics, ActionsObservable, StateObservable, ofType } from 'redux-observable';
import { RootAction, RootState } from '@src/app/_redux';
import { ApiClient } from '@src/app/_global/utility/apiUtils';
import { ApiConfig } from '@src/app/_global/domain';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { concat } from 'rxjs/observable/concat';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { actionCreators, REFUND_STORE_CREDIT_START } from '@src/app/accounts/refundstorecredit/actions';
import { actionCreators as weakActionCreators } from '@src/app/login/weak/actions';
import { actionCreators as gaActionCreators } from '@src/app/analytics/googleAnalytics/actions';
import { getLoggedInCustomer } from '@src/app/accounts/selectors';
import { RefundStoreCreditPostbody } from '@src/_api/payload/refund_store_credit';
import { forkJoin } from 'rxjs/observable/forkJoin';

const REFUND_STORE_CREDIT_PATH = '/payout';
const getStartRefundStoreCreditSucceeded = (...responses) => {
  const successResponses = responses.filter(item => 
    item.success === true);
  return successResponses;
};
const startRefundStoreCredit =  (
  action$: ActionsObservable<RootAction>,
  state$: StateObservable<RootState>,
) =>
    action$.pipe(
      ofType(REFUND_STORE_CREDIT_START),
      mergeMap(({ payload }) => {
      const client = new ApiClient();
      const clientConfig = state$.value.clientConfig.clientConfig;
      const loading = of(actionCreators.refundStoreCreditLoading(true));

      const promises = payload.map(refundStoreCreditPayload => {
        let postBody: RefundStoreCreditPostbody ;
        postBody = {
          resinCustomerId: refundStoreCreditPayload.resinCustomerId,
          resinClientId: refundStoreCreditPayload.resinClientId,
          refundAmount: refundStoreCreditPayload.refundAmount,
          resinPaymentInstrumentId: refundStoreCreditPayload.resinPaymentInstrumentId,
          path: refundStoreCreditPayload.path,
          systemCode: refundStoreCreditPayload.systemCode
        };

        const apiConfig: ApiConfig = {
          credentialsObject: state$.value.auth.omsAuth.credentials,
          url: clientConfig.url,
          path: REFUND_STORE_CREDIT_PATH,
          region: clientConfig.Region,
          requestmethod: 'POST',
          requestbody: postBody,
          parms: {},
          additionalParms: {
            headers: {
              'x-session-id': clientConfig.uuid
            },
          },
        };
        return fromPromise(client.callApiGateway(apiConfig));
      });
      let loggedIncustomer = getLoggedInCustomer(state$.value);
      const refetchCustomerPayload = {
        accountNumber: loggedIncustomer.accountNumber,
        postalCode: loggedIncustomer.postalCode,
      };
      let reloadCust = of(weakActionCreators.refetchCustomer(refetchCustomerPayload));
      const source$ = forkJoin(promises, getStartRefundStoreCreditSucceeded).pipe(
        map(responses => {
          let payloadCount = payload.length;
          if (payloadCount === responses.length) {
            gaActionCreators.createGAEvent({
              category: payload[0].googleAnalyticsCategory,
              action: 'Successful',
              label: payload[0].prodIdAlias,
              value: payload[0].refundAmount
            });
            return actionCreators.refundStoreCreditSuccess({payload, responses, success: true});
          } else {
            gaActionCreators.createGAEvent({
              category: payload[0].googleAnalyticsCategory,
              action: 'Unsuccessful',
              label: payload[0].prodIdAlias,
              value: payload[0].refundAmount
            });
            return actionCreators.refundStoreCreditError({
              success: false,
              message: 'Error on Store Credit Refund',
            });
          }
        }),
        catchError(err => {
          gaActionCreators.createGAEvent({
            category:  payload[0].googleAnalyticsCategory,
            action: 'Unknown Error',
            label: payload[0].prodIdAlias,
            value: payload[0].refundAmount
          });
          return of(
            actionCreators.refundStoreCreditError({ success: false, message: err }),
          );
        }),
      );
      return concat(loading, source$, reloadCust);
    }),
  );
export const epics = combineEpics(startRefundStoreCredit);
